// 获取模块主要获取数据模块
import request from '@/utils/request';

// 修改密码
export const modifyPassword = (data) => request({url: '/look/user/updateUser', method: 'put', data});